import React from 'react'

const WalletData = props => {
    let { paymentData } = props
    let { address, balance } = paymentData
    let translation = JSON.parse(localStorage.translation)[
        localStorage.language
    ]

    return (
        <div>
            <div className="payment__margin-bottom_s">
                <p className="payment__text-size_m">{firstLetterUppercase(translation['address'])}</p>
                <p className="payment__desc payment__desc_blue payment__text-ofh">
                    {address}
                </p>
            </div>
            <div className="payment__margin-bottom_s">
                <p className="payment__text-size_m">{firstLetterUppercase(translation['balance'])}</p>
                <p className="payment__desc">{`${balance} CPT`}</p>
            </div>
        </div>
    )
}

const firstLetterUppercase = str => {
    return (
        str.replace(/[^a-z||^a-я]/gi, ' ')[0].toUpperCase() +
        str.replace(/[^a-z||^a-я]/gi, ' ').slice(1)
    )
}

export default WalletData
